<div class="coverage-options-component">
  <form [formGroup]="coverageTermsForm">
    <div class="row">
      <div class="col-12 text-center pt-5 pb-3 pl-3 pr-3">
        <div [innerHTML]="getHtml(title, null)"></div>
        <div [innerHTML]="getHtml(subTitle, null)"></div>
      </div>
      <div class="w-100 select-coverage-deductible">
        <div class="p-2 pl-3 pr-3 text-center">
          <label for="coverageTermSelect">
            {{select_coverage_term}}
            <app-tooltip message="{{setTooltip(planSelected?.product?.productCode)}}"></app-tooltip>
          </label>
          <div class="w-100">
            <select id="coverageTermSelect" formControlName="terms" class="select-coverage-box" #selectCoverageBox>
              @for (term of (planSelected?.planTerms || chosenPlan?.planTerms); track $index; let i = $index) {
                <option [value]="term.value">
                  {{ checkTerm(term.label) }}
                </option>
              }
            </select>
          </div>
        </div>
        @if (multipleDeductibles && deductibles && (deductibles.length > 1  || deductibles.length == 1 && deductibles[0] !== 0)) {
          <div class="p-2 pl-3 pr-3 text-center">
            <label id="claimDeductibleLabel">{{select_claim_deductible}}</label>
            <div class="w-100">
              <mat-button-toggle-group #coverageDeductiblesBox class="coverage-deductibles-box"
                formControlName="deductible" name="deductible" aria-labelledby="claimDeductibleLabel"
                [hideSingleSelectionIndicator]="true">
                @for (deductible of deductibles; track $index; let j = $index) {
                  <mat-button-toggle [value]="deductible" id="selectClaimDeductible{{j}}"
                    (click)="chooseDeductible(deductible)">
                    ${{ deductible }}
                  </mat-button-toggle>
                }
              </mat-button-toggle-group>
            </div>
            @if (disappearingDeductible) {
              <mat-accordion>
                <mat-expansion-panel [expanded]="disappearingDeductiblePanel">
                  <div class="text-center disappearing_deductible mt-2 mb-2">
                    {{ 'RATES_PAGE.PAY_LESS' | translate }}
                    <app-tooltip message="{{odometerTooltip}}"></app-tooltip>
                </div>
                <div class="switch success-switch">
                  <label for="disappearingDeductible">
                    {{ 'RATES_PAGE.NO' | translate }}
                    <input id="disappearingDeductible"
                      [checked]="disappearingDeductibleValue" [value]="disappearingDeductibleValue" type="checkbox"
                      (click)="toggleDisappearing()">
                    <span class="lever"></span> {{ 'RATES_PAGE.YES' | translate }}
                  </label>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          }
        </div>
      }
    </div>
  </div>
  @if ((this.isBrand !== 'Lambo' && this.isBrand !== 'NCESI' && termMiles !== '0') || (this.isBrand === 'NCESI' && !isPPM && termMiles !== '0')) {
    <div class="text-center w-100 coverage-terms-container mt-3">
      <span class="estimated-coverage-text">{{ 'RATES_PAGE.ESTIMATED_COVERAGE' | translate }}: </span>
      <span class="pl-1 pr-1 estimated-coverage-terms"> {{expireDate | date: 'longDate' : preferredLanguage}}
        {{ 'RATES_PAGE.OR' | translate }} {{expireMileage | number }} {{('GENERIC.MILEAGE_PLURAL' |
      translate).toLowerCase()}}</span>
    </div>
  }
  @if (this.isBrand === 'Lambo') {
    <div class="text-center w-100 coverage-terms-container mt-3">
      <span class="estimated-coverage-text">{{ 'RATES_PAGE.ESTIMATED_COVERAGE' | translate }}: </span>
      <span class="pl-1 pr-1 estimated-coverage-terms">
        {{coverageDates.coverageStartDate | date: 'longDate' : preferredLanguage}}
        {{ 'RATES_PAGE.THROUGH' | translate }}
      {{coverageDates.coverageEndDate | date: 'longDate' : preferredLanguage}}</span>
    </div>
  }
  @if (this.isBrand === 'Porsche' && termMiles === '0') {
    <div class="text-center w-100 coverage-terms-container mt-3">
      <span class="estimated-coverage-text">{{ 'RATES_PAGE.ESTIMATED_COVERAGE' | translate }}: </span>
      <span class="pl-1 pr-1 estimated-coverage-terms">
      {{expireDate | date: 'longDate' : preferredLanguage}}</span>
    </div>
  }
</form>
</div>